import React, { createContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(localStorage.getItem('locale') || 'cat');
  const [languageLocale, setLanguageLocale] = useState('cat');

  

  useEffect(() => {
    let locale;
    switch (language) {
      case 'es_ES':
        locale = 'es';
        break;
      case 'ca_ES':
        locale = 'cat';
        break;
      case 'en_GB':
        locale = 'en';
        break;
      default:
        locale = 'cat';
    }
    setLanguageLocale(locale);
  }, [language]);

  useEffect(() => {
    i18n.changeLanguage(languageLocale);
    localStorage.setItem('locale', language);
    // Recarga la página cuando cambia el idioma
    // window.location.reload();
  }, [languageLocale, i18n, language]);

  const changeLanguage = (lng) => {
    setLanguage(lng);
  };

  return (
    <LanguageContext.Provider value={{ languageLocale, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export { LanguageProvider, LanguageContext };